import moment from 'moment';

export class SearchCondition {
  created_at_from: string = ""
  created_at_to: string = ""
  cram_code: string = ""
  sheet_code: string = ""
  student_name: string = ""
  status: string = ""
  course_type: string = ""
  grade: string = ""
  event_code: string = ""
}

export class CramStudent {
  base_sheet_id: number
  sheet_code: string
  nendo: number
  room_code: number
  class_code: number
  curriculum_id: number
  times: number
  examinee_id: number
  created_at: string
  student_code: number
  cram_code: number
  student_name: string
  result_downloaded_at: string
  score: number
  course_code: number
  isSelected: boolean = false

  constructor(x: any){
    this.base_sheet_id = x.base_sheet_id;
    this.sheet_code = x.sheet_code;
    this.nendo = x.nendo;
    this.room_code = x.room_code;
    this.class_code = x.class_code;
    this.curriculum_id = x.curriculum_id;
    this.times = x.times;
    this.examinee_id = x.examinee_id;
    this.created_at = moment(x.created_at).format("Y/M/D");
    this.student_code = x.student_code;
    this.cram_code = x.cram_code;
    this.student_name = x.student_name;
    this.result_downloaded_at = x.result_downloaded_at ? moment(x.result_downloaded_at).format("Y/M/D hh:mm:ss") : null;
    this.score = x.score;
    this.course_code = x.course_code;
  }
}